module.exports = __webpack_public_path__ + "img/4.8b1c63fb.jpg";